module.exports = __webpack_public_path__ + "static/media/gallery9.a21fa569.jpg";